import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { Systemlog } from '../systemlog.model';

export enum SystemlogActionTypes {
  UpsertSystemlogs = '[Systemlog] Upsert Systemlogs',
  GetSystemlogs = '[Systemlog] Get Systemlogs',
  GetSystemlogsFail = '[Systemlog] Get Systemlogs Fail',
  UpsertSystemlogsType = '[Systemlog] Upsert Systemlogs Type',
  GetSystemlogsType = '[Systemlog] Get Systemlogs Type',
  GetSystemlogsTypeFail = '[Systemlog] Get Systemlogs Type Fail',

}

export class UpsertSystemlogs implements Action {
  readonly type = SystemlogActionTypes.UpsertSystemlogs;

  constructor(public payload: any) {}
}

export class GetSystemlogs implements Action {
  readonly type = SystemlogActionTypes.GetSystemlogs;

  constructor(public payload: any = null) {}
}

export class GetSystemlogsFail implements Action {
  readonly type = SystemlogActionTypes.GetSystemlogsFail;

  constructor(public payload: any = null) {}
}

export class UpsertSystemlogsType implements Action {
  readonly type = SystemlogActionTypes.UpsertSystemlogsType;

  constructor(public payload: any) {}
}

export class GetSystemlogsType implements Action {
  readonly type = SystemlogActionTypes.GetSystemlogsType;

  constructor(public payload: any = null) {}
}

export class GetSystemlogsTypeFail implements Action {
  readonly type = SystemlogActionTypes.GetSystemlogsTypeFail;

  constructor(public payload: any = null) {}
}

export type SystemlogActions =
 UpsertSystemlogs
 | GetSystemlogs
 | GetSystemlogsFail
 | UpsertSystemlogsType
 | GetSystemlogsType
 | GetSystemlogsTypeFail;
